import { render, staticRenderFns } from "./Forbidden.template.vue?vue&type=template&id=cc23b42e&scoped=true&"
var script = {}
import style0 from "./Forbidden.template.vue?vue&type=style&index=0&id=cc23b42e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc23b42e",
  null
  
)

export default component.exports